<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <li>
            <router-link
              to="/"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li @click="handleOrderCenterClick">
            <span
              style="cursor: pointer;color: #333;text-decoration: none;transition: color 0.3s;"
              :class="{ active: $route.name === 'orderList' }"
            >
              订单中心
            </span>
          </li>
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li>
            <span
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </span>
          </li>
          <li @click="handleOrderCenterClick">
            <span
              style="cursor: pointer;"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'product' }"
            >
              订单中心
            </span>
          </li>
        </ul>
      </div>
    </nav>
    <!-- 主要内容区域 -->
    <main class="insure-main">
      <div class="container">
        <h2 class="page-title">保险投保申请</h2>
        <!-- 方案信息 -->
        <div class="form-section applicant-info">
          <h3 class="section-title">方案信息</h3>
          <div class="plan-selector">
            <h3>选择保障方案</h3>
            <br/>
            <div class="product-list">
              <div class="plan-buttons">
                <el-checkbox-group v-model="selectedPlans">
                  <el-checkbox-button
                    v-for="plan in plans"
                    :key="plan.id"
                    :label="plan.id"
                    class="plan-btn"
                    @change="handlePlanChange($event,plan.id)"
                  >
                    {{ plan.name }}
                  </el-checkbox-button>
                </el-checkbox-group>
              </div>
            </div>
            <div class="accessory-switch" v-if="selectedPlans.includes(0)">
              <h4 style="margin:15px 0 10px">附加保障</h4>
              <el-switch
                @change="calculatePremium"
                v-model="accessoryTheft"
                active-value="1"
                inactive-value="0"
                active-text="附加盗窃险"
                inactive-text="不附加"
                active-color="#13ce66"
              />
            </div>
          </div>

        </div>

        <!-- 设备信息 -->
        <div class="form-section applicant-info">
          <h3 class="section-title">设备信息</h3>
          <!-- 设备表格 -->
          <div class="device-table" v-if="deviceList.length">
            <el-table
              :data="deviceList"
              style="width: 100%"
              @selection-change="handleSelectionChange"
            >
              <el-table-column type="selection" width="55" ></el-table-column>
              <el-table-column prop="saleId" label="销售单编码" min-width="120" header-align="center"
                               align="center"></el-table-column>
              <el-table-column prop="deviceName" label="设备名称" min-width="110" header-align="center"
                               align="center"></el-table-column>
              <el-table-column prop="actualNumber" label="设备数量" width="80" header-align="center"
                               align="center"></el-table-column>
              <el-table-column prop="devicePort" label="端口数量" width="80" header-align="center"
                               align="center"></el-table-column>
              <el-table-column prop="deviceModel" label="型号" min-width="130" header-align="center"
                               align="center"></el-table-column>
              <el-table-column prop="devicePrice" label="单价(元)" width="100" header-align="center"
                               align="center">
                <template #default="{row}">
                  {{ row.devicePrice.toFixed(2) }}
                </template>
              </el-table-column>
              <el-table-column prop="deviceFamily" label="设备分类" width="140" header-align="center" align="center">
                <template #default="{row}">
                  <span v-if="row.deviceFamily === 0">电瓶车充电桩</span>
                  <span v-else-if="row.deviceFamily === 7">汽车直流桩</span>
                  <span v-else-if="row.deviceFamily === 8">汽车交流桩</span>
                  <span v-else>未知类型</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 发票信息 -->
        <div class="form-section">
          <h3 class="section-title">发票信息</h3>
          <div class="form-group">
            <label>发票类型：</label>
            <div class="radio-group">
              <label>
                <input type="radio" value="0" v-model="invoiceType"> 不需要发票
              </label>
              <label>
                <input type="radio" value="1" v-model="invoiceType"> 增值税普通发票
              </label>
              <label>
                <input type="radio" value="2" v-model="invoiceType"> 增值税专用发票
              </label>
            </div>
          </div>
          <!-- 在发票类型选择后添加 -->
<!--          <div class="form-group" v-if="invoiceType !== '0'">-->
<!--            <el-button type="text" @click="showPasteDialog" icon="el-icon-document-copy">-->
<!--              智能粘贴发票信息-->
<!--            </el-button>-->
<!--          </div>-->

          <!-- 在手机号码表单项下方添加 -->
          <div class="form-group" v-if="invoiceType === '1'||invoiceType === '2'">
            <label>纳税人姓名：</label>
            <el-input
              v-model="applicant.companyName"
              placeholder="请输入纳税人姓名"
            >
            </el-input>
          </div>

          <div class="form-group" v-if="invoiceType === '1'||invoiceType === '2'">
            <label>纳税人识别号：</label>
            <el-input
              v-model="applicant.taxPayerNo"
              placeholder="请输入15位纳税人识别号"
            >
            </el-input>
          </div>

          <div class="form-group" v-if="invoiceType === '2'">
            <label>开户银行：</label>
            <el-input
              v-model="applicant.depositeBankName"
              placeholder="请输入开户银行全称"
            ></el-input>
          </div>

          <div class="form-group" v-if="invoiceType === '2'">
            <label>银行账号：</label>
            <el-input
              v-model="applicant.accountNo"
              placeholder="请输入企业银行账号"
              type="number"
            ></el-input>
          </div>

          <div class="form-group" v-if="invoiceType === '2'">
            <label>税务登记地址：</label>
            <el-input
              v-model="applicant.taxRegisterAddress"
              placeholder="请输入营业执照登记地址"
            ></el-input>
          </div>

          <div class="form-group" v-if="invoiceType === '2'">
            <label>税务登记电话：</label>
            <el-input
              v-model="applicant.taxRegisterTel"
              placeholder="请输入税务登记联系电话"
              type="tel"
            ></el-input>
          </div>
        </div>

        <!-- 投/被保人信息 -->
        <div class="form-section">
          <h3 class="section-title">投/被保人信息</h3>
          <div class="insured-actions">
            <!-- 模板下载按钮 -->

            <!-- 新增：上传/下载按钮组 -->
            <div class="insured-actions">
              <el-button type="text" @click="showPasteModal = true" icon="el-icon-document-copy">
                智能粘贴投/被保人信息
              </el-button>
            </div>
          </div>
          <div class="form-group">
            <label>客户类型：</label>
            <el-select
              v-model="applicant.appliIdType"
              @change="syncInsuredInfo"
              style="width: 100%"
            >
              <el-option label="企业" :value="5"></el-option>
              <el-option label="自然人" :value="111"></el-option>
            </el-select>
          </div>

          <div class="form-group">
            <label>{{ applicant.appliIdType === 5 ? '企业名称' : '姓名' }}：</label>
            <el-input
              v-model="applicant.appliName"
              :placeholder="applicant.appliIdType === 5 ? '请输入企业全称' : '请输入姓名'"
              @input="syncInsuredInfo"
            ></el-input>
          </div>

          <div class="form-group">
            <label>{{ applicant.appliIdType === 5 ? '统一信用代码' : '身份证号' }}：</label>
            <el-input
              v-model="applicant.appliIdNo"
              :placeholder="applicant.appliIdType === 5 ? '请输入18位统一社会信用代码' : '请输入18位身份证号码'"
              @input="syncInsuredInfo"
            ></el-input>
          </div>

          <div class="form-group">
            <label>手机号码：</label>
            <el-input
              v-model="applicant.mobile"
              placeholder="请输入接收发票的手机号"
              @input="syncInsuredInfo"
            >
            </el-input>
          </div>
        </div>

        <!-- 阅读文档区域 -->
        <div class="doc-section">
          <div class="doc-header">
            <input
              type="checkbox"
              id="check-all"
              v-model="checkAll"
              @click.prevent="handleDocCheck"
              :class="{ 'allow-check': checkAllAllowed }"
            >
            <label for="check-all">我已阅读并同意以下所有文档</label>
          </div>
          <div class="doc-list">
            <div
              class="doc-item"
              v-for="doc in docList"
              :key="doc.id"
              @click="handleDocCheck"
            >
              {{ doc.name }}
            </div>
          </div>
        </div>
        <!-- 粘贴信息弹窗 -->
        <div class="modal" v-show="showPasteModal">
          <div class="modal-content">
            <h3>智能粘贴投/被保险人信息</h3>
            <button class="close-btn" @click="showPasteModal = false">×</button>
            <!-- 修改提示文案 -->
            <ul class="tip-list">
              <li> 姓名/企业名称</li>
              <li> 身份证号/统一信用代码</li>
              <li> 手机号（11位数字）</li>
              <li> 客户类型（自动识别证件号）</li>
            </ul>
            <p>示例1（自然人）：张三 13800138000 440101199001011234</p>
            <p>示例2（企业）：广东广福公司 91440000MABCDEF123 13912345678</p>
            <textarea
              v-model="pasteContent"
              placeholder="粘贴单条信息后自动识别"
            ></textarea>
            <button class="confirm-btn" @click="handlePaste">确认添加</button>
          </div>
        </div>

        <!-- 添加发票粘贴信息弹窗 -->
        <el-dialog title="智能粘贴" :visible.sync="dialogVisible" width="600px">
          <div v-if="invoiceType === '1'">
            <p>示例格式（参数顺序不限）：</p>
            <pre>
纳税人识别号: 91440300MA5FABCD12
纳税人姓名: 广东广福宏宇保险经纪有限公司
      </pre>
          </div>

          <div v-if="invoiceType === '2'">
            <p>示例格式（参数顺序不限）：</p>
            <pre>
纳税人识别号: 91440300MA5FABCD12
开户银行: 中国银行深圳分行
银行账号: 1234567890123456789
登记地址: 深圳市福田区XX路XX号
登记电话: 0755-12345678
      </pre>
          </div>

          <el-input
            type="textarea"
            v-model="pasteContent"
            placeholder="请粘贴发票信息..."
            rows="5"
          ></el-input>

          <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>

          <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="parsePastedText">解析并填充</el-button>
    </span>
        </el-dialog>
      </div>
    </main>

    <!-- 文档内容弹窗 -->
    <div class="doc-modal" v-show="showDocModal">
      <div class="modal-content">
        <h3>{{ currentDocTitle }}</h3>
        <button class="close-btn" @click="showDocModal = false">×</button>
        <div class="doc-content" ref="docContent" style="max-height: 60vh; overflow-y: auto;">
          <div
            v-if="showDocModal"
            class="rich-text-content"
            v-html="currentDocContent"
            style="white-space: pre-wrap; line-height: 1.6;"
          ></div>
        </div>
        <div class="button-container">
          <button
            type="primary"
            class="doc-button"
            @click="ok()"
            v-if="Number(sort-1)!=t"
          >
            已阅读，并同意上述内容({{ Number(t+1) }}/{{ sort }})
          </button>

          <button
            type="primary"
            class="doc-button"
            @click="gbi()"
            v-if="Number(sort-1)==t"
          >
            已阅读，并同意上述内容({{ Number(t+1) }}/{{ sort }})
          </button>
        </div>
      </div>
    </div>

    <!-- 底部固定导航栏 -->
    <div class="fixed-footer">
      <div class="container">
        <div class="footer-content">
          <span class="price">金额：¥{{ totalPrice }}</span>
          <button
            class="submit-btn"
            @click="handleSubmit"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? '投保中...' : '立即投保' }}
          </button>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2025 广东广福宏宇保险经纪有限公司 粤ICP备2025485413号-1 服务及投诉电话：400-867-5672</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>
  </div>
</template>

<script>

import {service, shopService} from '../../utils/axios'
// import {record} from 'rrweb'

// let events = []
export default {
  name: 'orderInsZFG',
  data () {
    return {
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showBackToTop: false, // 返回顶部按钮显示状态
      showDocModal: false, // 文档弹窗显示状态
      currentDocTitle: '', // 当前显示的文档标题
      currentDocContent: '', // 当前显示的文档内容
      checkAllAllowed: false, // 阅读文档复选框
      // 投保人信息
      applicant: {
        name: '',
        idType: '身份证',
        idNumber: '',
        phone: '',
        // 发票字段
        companyName: '',
        taxPayerNo: '',
        depositeBankName: '',
        accountNo: '',
        taxRegisterAddress: '',
        taxRegisterTel: ''
      },
      // 是否盗窃0否1是
      accessoryTheft: '0',
      // 发票类型
      invoiceType: '0',
      // 粘贴弹窗相关
      showPasteModal: false,
      pasteContent: '',
      docList: [ // 阅读文档列表
        { id: 1, name: '保险条款', content: '（文档内容...）' },
        { id: 2, name: '隐私政策', content: '（文档内容...）' },
        { id: 3, name: '免责声明', content: '（文档内容...）' }
      ],
      sort: 1,
      t: 0,
      checkAll: false, // 全选状态
      checkedDocs: [], // 已勾选的文档ID
      currentDoc: null, // 当前显示的文档
      isSubmitting: false, // 提交中状态
      totalPrice: 0, // 示例应付金额
      eqyaPremium: 0, // 对应产品应付金额
      sqyaPremium: 0, // 对应产品应付金额
      szcgPremium: 0, // 对应产品应付金额
      // 模拟文档数据
      docData: {
        '保险服务条款': '一、服务范围\n1.1 本保险服务覆盖家庭财产、机动车辆等常见保险类型，具体保障内容以保单约定为准。\n二、责任免除\n2.1 因投保人故意行为、战争、核辐射等不可抗力导致的损失，本公司不承担赔偿责任。',
        '隐私保护协议': '第一条 数据收集\n1.1 我们将收集投保人姓名、身份证号、联系方式等必要信息用于保单服务。\n第二条 数据使用\n2.1 仅用于保险服务相关流程，未经授权不会向第三方披露。',
        '免责声明': '一、责任免除\n1.1 被保险人未履行如实告知义务导致的损失，本公司不承担赔偿责任。\n二、争议解决\n2.1 本协议未尽事宜，双方可协商解决；协商不成的，提交有管辖权的人民法院诉讼解决。'
      },
      selectedPlans: [],
      plans: [
        {id: 0, name: '二轮场地险'},
        {id: 7, name: '四轮场地险'}
        // { id: 8, name: '四轮财产险' }
      ],
      deviceList: [],
      // ...发票黏贴弹窗...
      dialogVisible: false,
      errorMessage: '',
      // 储存已选设备
      selectedDevices: []
    }
  },
  computed: {

  },

  created () {
    this.initDocuments()
  },

  mounted () {
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 处理表格选择变化
    handleSelectionChange (selection) {
      if (selection.length > 0) {
        this.selectedDevices = selection
        this.calculatePremium()
      } else {
        this.selectedDevices = selection
        this.totalPrice = 0
      }
      console.log('当前选中设备:', selection)
    },

    async calculatePremium () {
      try {
        const requestData = {
          devices: this.selectedDevices.map(device => ({
            deviceFamily: device.deviceFamily,
            devicePort: device.devicePort,
            actualNumber: device.actualNumber,
            devicePrice: device.devicePrice
          })),
          productTypes: this.selectedPlans.join(','),
          needTheft: this.accessoryTheft
        }

        const res = await service.post('/website/calculatePremium', requestData)
        console.log('保费计算结果:', res)
        if (res.success) { // 成功
          const details = res.result.detailAmount || {}
          // 分别存储各产品保费
          this.eqyaPremium = Number(details.EZCG) || 0
          this.sqyaPremium = Number(details.SQYA) || 0
          this.szcgPremium = Number(details.SZCG) || 0
          this.totalPrice = [
            Number(details.EZCG) || 0,
            Number(details.SQYA) || 0,
            Number(details.SZCG) || 0
          ].reduce((sum, val) => sum + val, 0)
        } else { // 失败

        }
        // 这里可以添加保费展示逻辑，例如：
        // this.premiumAmount = res.data.totalPremium
      } catch (error) {
        console.error('保费计算失败:', error)
        this.$message.error('保费计算失败，请检查设备选择')
      }
    },

    handlePlanChange (isChecked, planId) {
      console.log(planId)
      if (planId !== null) {
        // 获取当前所有选中方案的ID
        const selectedIds = this.selectedPlans
        console.log(selectedIds)
        this.getDeviceData(selectedIds.join(','))
      }
    },
    // 初始化文档
    async initDocuments () {
      this.docList = []
      const res = await shopService.post('/MiniProgram/agreementListTwo', {
        requiredBookType: '1',
        type: '1813839391528894978'
      })

      if (res.data.success) { // 成功
        this.docList = res.data.result
        this.sort = res.data.result.length
        this.currentDocTitle = this.docList[0].name
        this.currentDocContent = this.docList[0].content
      } else { // 失败

      }
    },

    ok () {
      // 添加滚动到顶部功能
      this.$nextTick(() => {
        const container = this.$refs.docContent
        if (container) {
          container.scrollTop = 0
        }
      })
      if (this.sort > 0) {
        this.t = this.t + 1
        if (this.docList[Number(this.t)] != null) {
          console.log(this.docList[Number(this.t)])
          this.currentDocContent = this.docList[Number(this.t)].content
          this.currentDocTitle = this.docList[Number(this.t)].name
        } else {
          this.t = this.t--
        }
      } else if (this.sort === 0) {

      }
    },

    gbi () {
      if (this.t === this.docList.length - 1) {
        this.checkAll = true
        this.showDocModal = false
      }
    },

    syncInsuredInfo () {
      // 同步到被保人字段
      this.insured = {
        insuredIdType: this.applicant.appliIdType,
        insuredName: this.applicant.appliName,
        insuredIdNo: this.applicant.appliIdNo,
        insuredMobile: this.applicant.mobile
      }
    },
    // 粘贴信息处理
    // 修改粘贴信息处理逻辑
    handlePaste () {
      const lines = this.pasteContent.split('\n').filter(line => line.trim())
      if (lines.length > 1) {
        this.$message.error('每次只能粘贴一条被保险人信息')
        return
      }

      const parsedData = {
        name: '',
        idType: 111, // 默认自然人
        idNumber: '',
        mobile: ''
      }

      // 智能字段识别
      lines[0].split(/\s+/).forEach(item => {
        // 匹配手机号
        if (/^1[3-9]\d{9}$/.test(item)) {
          parsedData.mobile = item
          // eslint-disable-next-line brace-style
        }
        // 匹配身份证号
        else if (/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(item)) {
          parsedData.idNumber = item.toUpperCase()
          parsedData.idType = 111
          // eslint-disable-next-line brace-style
        }
        // 匹配统一信用代码
        else if (/^[A-Z0-9]{18}$/.test(item)) {
          parsedData.idNumber = item
          parsedData.idType = 5
          // eslint-disable-next-line brace-style
        }
        // 匹配性别
        else if (['男', '女'].includes(item)) {
          // 性别字段暂不处理
          // eslint-disable-next-line brace-style
        }
        // 默认为姓名
        else {
          parsedData.name = item
        }
      })

      // 同步到投保人和被保人
      this.applicant = {
        appliIdType: parsedData.idType,
        appliName: parsedData.name,
        appliIdNo: parsedData.idNumber,
        mobile: parsedData.mobile
      }
      this.syncInsuredInfo()
      this.showPasteModal = false
    },
    // 切换文档显示
    toggleDoc (doc) {
      this.currentDoc = this.currentDoc.id === doc.id ? null : doc
    },

    // 新增：点击复选框触发文档查看
    handleDocCheck () {
      if (this.t === this.docList.length - 1) {
        this.checkAllAllowed = true
        this.checkAll = !this.checkAll
      }
      // if (!this.checkAll) return // 取消勾选不触发
      this.showDocModal = true
    },

    // 立即投保处理
    async handleSubmit () {
      // 验证保障方案选择
      if (this.selectedPlans.length === 0) {
        this.$message.error('请至少选择一个保障方案')
        return
      }

      // 验证设备选择
      if (this.selectedDevices.length === 0) {
        this.$message.error('请至少选择一个设备')
        return
      }

      // 验证发票信息
      if (this.invoiceType === 0) { // 普票
        if (!this.taxpayerName || !this.taxpayerId) {
          this.$message.error('普票需要填写纳税人姓名和识别号')
          return
        }
      } else if (this.invoiceType === 1) { // 专票
        const requiredFields = [
          !this.taxpayerName && '纳税人姓名',
          !this.taxpayerId && '纳税人识别号',
          !this.bankName && '开户银行',
          !this.bankAccount && '银行账号',
          !this.taxAddress && '税务登记地址',
          !this.taxPhone && '税务登记电话'
        ].filter(Boolean)

        if (requiredFields.length > 0) {
          this.$message.error(`专票需要填写：${requiredFields.join('、')}`)
          return
        }
      }

      // 验证投保人信息
      const applicantRequired = [
        !this.applicant.appliName && '姓名',
        !this.applicant.appliIdType && '证件类型',
        !this.applicant.appliIdNo && '证件号码',
        !this.applicant.mobile && '手机号码'
      ].filter(Boolean)

      if (applicantRequired.length > 0) {
        this.$message.error(`投/被保人信息缺失：${applicantRequired.join('、')}`)
        return
      }

      // 验证被保人信息（不同步时）
      if (!this.syncInfo) {
        const insuredRequired = [
          !this.insured.insuredName && '姓名',
          !this.insured.insuredIdType && '证件类型',
          !this.insured.insuredIdNo && '证件号码',
          !this.insured.insuredMobile && '手机号码'
        ].filter(Boolean)

        if (insuredRequired.length > 0) {
          this.$message.error(`被保人信息缺失：${insuredRequired.join('、')}`)
          return
        }
      }

      // 验证文档阅读状态
      if (!this.checkAll) {
        this.$message.error('请先阅读并同意相关协议条款')
        return
      }

      // 所有验证通过后执行投保操作
      this.isSubmitting = true
      // 构造请求数据
      // 构造请求数据
      const requestData = {
        types: this.selectedPlans.map(planId =>
          planId === 0 ? 'EZCG'
            : planId === 7 ? 'SQYA'
              : 'SZCG'
        ),
        accessoryTheft: Number(this.accessoryTheft),
        mainForm: {
          appliName: this.applicant.appliName,
          appliIdType: this.applicant.appliIdType,
          appliIdNo: this.applicant.appliIdNo,
          appliIdMobile: this.applicant.mobile,
          insuredName: this.insured.insuredName || '', // 修改字段名
          insuredIdNo: this.insured.insuredIdNo || '', // 修改字段名
          insuredIdType: this.insured.insuredIdType, // 修改字段名
          insuredIdMobile: this.insured.insuredMobile || '', // 修改字段名
          needInvoice: Number(this.invoiceType),
          taxPhone: this.applicant.taxRegisterTel,
          taxAddress: this.applicant.taxRegisterAddress,
          bankName: this.applicant.depositeBankName,
          bankAccount: this.applicant.accountNo,
          taxpayerName: this.applicant.companyName,
          taxpayerId: this.applicant.taxPayerNo,
          paymentAmount: this.totalPrice,
          saleId: this.$route.query.saleId,
          amountOrder: 0,
          accessoryTheft: Number(this.accessoryTheft),
          // 新增各产品保费字段
          eqyaPremium: this.eqyaPremium,
          sqyaPremium: this.sqyaPremium,
          szcgPremium: this.szcgPremium,
          mobile: this.applicant.mobile
        },
        deviceList: this.selectedDevices.map(device => ({
          id: device.id,
          deviceModel: device.deviceModel,
          deviceFamily: device.deviceFamily,
          devicePort: device.devicePort,
          actualNumber: device.actualNumber,
          devicePrice: device.devicePrice
        }))
      }

      try {
        const res = await service.post('/website/createApplication', requestData)
        // 调用投保接口
        if (res.success) {
          this.$message.success('预投保申请提交成功')
          const payUrl = res.result.payUrl // 假设接口返回支付地址字段为payUrl
          navigator.clipboard.writeText(payUrl).then(() => {
            this.$message.success('支付地址已复制，请用微信打开链接完成支付')
            this.resetFormData() // 重置表单数据
          }).catch(() => {
            this.$message.error('自动复制失败，请手动复制支付地址')
          })
          // 这里可以添加跳转到订单详情页的逻辑
          // this.$router.push(`/order/${res.data.result.orderId}`);
        } else {
          this.$message.error(res.data.message || '投保失败')
        }
      } catch (error) {
        console.error('投保请求异常:', error)
        this.$message.error('网络异常，请稍后重试')
      } finally {
        this.isSubmitting = false
      }
    },

    async getDeviceData (productIds) {
      try {
        console.log('走这里')
        // 实际请求时需要替换为真实接口调用
        console.log('请求参数:', productIds)
        // 新增：检查saleId是否存在
        if (!this.$route.query.saleId) {
          this.$message.error('销售单号不能为空')
          return
        }
        const res = await service.get('/website/queryDevices', {
          params: {
            saleId: this.$route.query.saleId,
            deviceFamily: productIds // 参数已经是字符串，无需再次join
          },
          timeout: 10000 // 添加超时设置
        })
        console.log('响应数据:', res)
        console.log(res)
        // 合并新旧设备列表
        if (res.success) { // 成功
          // 新增：为每个设备添加isSelected字段并设置为true
          this.deviceList = res.result.map(device => ({
            ...device,
            isSelected: false
          }))
        } else { // 失败
          this.$message.error('设备数据获取失败')
        }
      } catch (error) {
        this.$message.error('设备数据获取失败')
      }
    },

    // 发票粘贴方法
    showPasteDialog () {
      this.dialogVisible = true
      this.pasteContent = ''
      this.errorMessage = ''
    },

    parsePastedText () {
      const mapping = {
        '纳税人姓名': 'companyName',
        '纳税人识别号': 'taxPayerNo',
        '开户银行': 'depositeBankName',
        '银行账号': 'accountNo',
        '登记地址': 'taxRegisterAddress',
        '登记电话': 'taxRegisterTel'
      }

      try {
        const lines = this.pasteContent.split(/[\n,，]/)
        lines.forEach(line => {
          const [key, value] = line.split(/[:：]/).map(s => s.trim())
          if (key && value && mapping[key]) {
            this.applicant[mapping[key]] = value
          }
        })
        this.dialogVisible = false
      } catch (e) {
        this.errorMessage = '解析失败，请检查格式是否正确'
      }
    },

    // 订单中心跳转
    handleOrderCenterClick () {
      if (this.$route.query.saleId) {
        this.$router.push({
          path: '/orderList',
          query: { saleId: this.$route.query.saleId }
        })
      } else {
        this.$message.error('当前页面缺少销售单号，无法查看订单')
      }
    },

    resetFormData () {
      // 保留不需要重置的字段（如设备列表、移动端状态）
      const preservedData = {
        isMobile: this.isMobile,
        deviceList: [] // 清空设备列表
      }

      // 合并初始数据和需要保留的状态
      Object.assign(this.$data, {
        ...this.$options.data.call(this),
        ...preservedData
      })

      // 额外重置计算字段
      this.totalPrice = 0
      this.eqyaPremium = 0
      this.sqyaPremium = 0
      this.szcgPremium = 0
    },

    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({top: 0, behavior: 'smooth'})
    },
    // 回溯
    downloadTwo (vlaue) {
      // let self = this
      // self.stopFn = record.record({
      //   packFn: record.pack,
      //   emit (event) {
      //     if (events.length > Number(vlaue)) {
      //       // 当事件数量大于 100 时停止录制
      //       self.stopFn()
      //     }
      //     // 处理下拉框事件数据
      //     if (event.type === 'change' && event.target.tagName === 'SELECT') {
      //       event.data = { value: event.target.value }
      //     }
      //     // console.log(event)
      //     events.push(event)
      //     let a = events
      //     a.push(event)
      //     sessionStorage.setItem('events', JSON.stringify(a))
      //   },
      //   sampling: {
      //     // 不录制鼠标移动事件
      //     mousemove: false,
      //     // 不录制鼠标交互事件
      //     mouseInteraction: false,
      //     scroll: 1000, // 每 150ms 最多触发一次
      //     // set the interval of media interaction event
      //     media: 800,
      //     input: 'last' // 连续输入时，只录制最终值
      //   }
      // })
      // this.$emit("start", self.events);
    }
  }
}
</script>
<style scoped>
/* 阅读文档区域 */
.doc-section {
  margin-top: 25px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
}

.doc-header {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.doc-list {
  display: flex;
  gap: 20px;
  overflow-x: auto; /* 横向滚动 */
  padding: 10px 0;
}

.doc-item {
  flex-shrink: 0; /* 防止内容被压缩 */
  white-space: nowrap; /* 文字不换行 */
}

.doc-item input {
  margin-right: 5px;
}

/* 半弹窗 */
.doc-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  padding: 20px;
  border-radius: 8px;
  overflow-y: auto;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.2rem;
  cursor: pointer;
}

.doc-content {
  margin-top: 25px;
  line-height: 1.8;
  font-size: 0.95rem;
}

/* 底部固定导航栏 */
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  padding: 15px 0;
  z-index: 999;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.price {
  color: #e74c3c;
  font-size: 1.1rem;
  font-weight: bold;
}

.submit-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.3s;
}

.submit-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* 新增/修改样式 */
.insure-main {
  margin-top: 80px; /* 导航栏高度 */
  padding: 20px 0 100px; /* 底部预留固定导航栏空间 */
}

.form-section {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.section-title {
  font-size: 1.4rem;
  color: #3498db;
  margin-bottom: 20px;
}

.form-group {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 15px;
  margin-bottom: 15px;
  align-items: center;
}

.form-group input, .form-group select {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 新增上传表单样式 */
.insure-main {
  margin-top: 100px; /* 导航栏高度 */
  padding: 30px 0;
}

.insured-actions {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap; /* 小屏幕换行 */
}

.upload-btn, .download-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 1rem;
  transition: opacity 0.3s;
}

.upload-btn {
  background: #2ecc71; /* 上传按钮绿色 */
  color: white;
}

.download-btn {
  background: #3498db; /* 下载按钮蓝色 */
  color: white;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.upload-btn:hover, .download-btn:hover {
  opacity: 0.9;
}

/* 模板下载按钮 */
.template-download {
  margin-bottom: 30px;
  text-align: center;
}

.download-btn {
  display: inline-block;
  background: #2ecc71;
  color: white;
  padding: 12px 25px;
  border-radius: 6px;
  text-decoration: none;
  font-size: 1rem;
  transition: background 0.3s;
}

.download-btn:hover {
  background: #27ae60;
}

/* 移动端适配（屏幕宽度≤768px） */
@media (max-width: 768px) {
  .doc-list {
    gap: 15px;
    padding: 10px 5px;
  }

  .doc-item {
    font-size: 0.9rem;
  }

  .fixed-footer .container {
    padding: 0 10px;
  }

  .price {
    font-size: 1rem;
  }

  .submit-btn {
    padding: 8px 20px;
    font-size: 0.95rem;
  }

  .form-section {
    padding: 15px; /* 缩小表单内边距 */
  }

  .section-title {
    font-size: 1.2rem; /* 缩小标题字体 */
  }

  .form-group {
    grid-template-columns: 1fr; /* 小屏幕下标签和输入框垂直排列 */
    gap: 8px;
  }

  .form-group label {
    font-size: 0.9rem; /* 缩小标签字体 */
  }

  .form-group input, .form-group select {
    padding: 6px; /* 缩小输入框内边距 */
    font-size: 0.9rem; /* 缩小输入框字体 */
  }

  .radio-group {
    flex-direction: column; /* 小屏幕下单选按钮垂直排列 */
    gap: 12px;
  }
}

@media (max-width: 768px) {
  .insured-actions {
    flex-direction: column; /* 小屏幕垂直排列 */
    gap: 10px;
  }

  .upload-btn, .download-btn {
    width: 100%; /* 按钮占满宽度 */
    justify-content: center;
  }
}

.insure-main {
  margin-top: 30px; /* 导航栏高度 */
  padding: 20px 0;
}

@media (max-width: 768px) {
  .insure-main .container {
    padding: 0 10px; /* 缩小容器内边距 */
  }

  .form-group {
    grid-template-columns: 1fr; /* 表单标签和输入框垂直排列 */
    gap: 8px;
  }

  .form-group label {
    font-size: 0.9rem;
  }

  .insured-list table {
    min-width: 600px; /* 表格最小宽度，配合横向滚动 */
  }

  .insured-list {
    overflow-x: auto; /* 小屏幕表格横向滚动 */
  }

  .modal-content {
    width: 95%; /* 弹窗宽度占满屏幕 */
    padding: 20px;
  }
}

.insure-main {
  margin-top: 30px;
  padding: 30px 0;
}

.page-title {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 30px;
}

.form-section {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  margin-bottom: 30px;
}

.section-title {
  font-size: 1.4rem;
  color: #3498db;
  margin-bottom: 20px;
}

.radio-group {
  display: flex;
  gap: 20px;
}

.radio-group label {
  display: flex;
  align-items: center;
  gap: 8px;
}

.insured-actions {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.upload-btn, .paste-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.upload-btn {
  background: #2ecc71;
  color: white;
}

.paste-btn {
  background: #3498db;
  color: white;
}

.insured-list table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 15px;
}

.insured-list th, .insured-list td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.insured-list th {
  background: #3498db;
  color: white;
}

.empty-tip {
  color: #999;
  text-align: center;
  padding: 20px;
}

/* 弹窗样式 */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  position: relative;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal textarea {
  width: 100%;
  height: 150px;
  padding: 10px;
  margin: 15px 0;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.confirm-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

/* 新增/修改样式 */
.homepage {
  display: flex; /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh; /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1; /* 内容区域自动扩展占据剩余空间 */
}

/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto; /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}

/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}

/* 新增样式 */
/* 导航栏选中状态 */
.desktop-menu .active a,
.mobile-menu .active a {
  color: #3498db;
  font-weight: bold;
  position: relative;
}

.desktop-menu .active a::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #3498db;
}

/* 产品分类列表 */
.product-categories {
  margin: 120px 0 40px;
}

.category-list {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.category-list button {
  padding: 8px 20px;
  border: 1px solid #ddd;
  border-radius: 20px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s;
}

.category-list button:hover,
.category-list button.active {
  background: #3498db;
  color: white;
  border-color: #3498db;
}

/* 产品列表 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 30px;
  margin-top: 30px;
}

.product-card {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 8px;
  transition: transform 0.3s;
}

.product-card:hover {
  transform: translateY(-5px);
}

.product-image {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 15px;
}

.price {
  color: #e74c3c;
  font-size: 1.2rem;
  margin: 10px 0;
}

/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}

/* 方案按钮样式 */
.product-list {
  display: flex;
  justify-content: center; /* 水平居中 */
  gap: 20px; /* 按钮间距 */
  flex-wrap: wrap; /* 允许换行 */
}

.plan-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.plan-btn {
  width: 180px;
  height: 60px;
  border-radius: 8px !important;
}

.plan-btn.is-checked {
  background: #e6f7ff;
  border-color: #1890ff;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .product-list {
    flex-direction: column;
    align-items: center; /* 移动端居中排列 */
  }

  .plan-buttons {
    flex-direction: column;
    width: 100%;
  }

  .plan-btn {
    width: 100%;
    margin-bottom: 10px;
  }
}

/* 移动端表格适配 */
@media (max-width: 768px) {
  .device-table {
    overflow-x: auto;
  }

  .el-table {
    min-width: 600px; /* 保持表格最小宽度 */
  }

  .el-table__body {
    font-size: 14px;
  }
}

/* 发票黏贴弹窗样式*/
.error-message {
  color: #f56c6c;
  margin-top: 10px;
}

/* 新增按钮容器样式 */
.button-container {
  margin-top: 20px;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}

.doc-button {
  padding: 10px 20px;
  background: #409EFF;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

/* 文档复选框*/
/* 添加样式控制 */
#check-all {
  opacity: 0.6;
}

#check-all.allow-check {
  opacity: 1;
}

/* 新增移动端样式 */
@media (max-width: 768px) {
  .form-group .radio-group {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  .radio-group label {
    margin: 0 8px;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/lcc/lccInsure.vue